import ViajesView from '../ViajesView.vue'
import RideList from '../Pages/RideList.vue'
import RideEditor from '../Pages/RideEditor.vue'

const routes = [
  {
    path: '/viajes',
    component: ViajesView,
    name: 'viajes',
    children: [
      {
        path: 'lista',
        name: 'viajes-ride-list',
        component: RideList
      },
      {
        path: 'crear',
        name: 'viajes-ride-create',
        component: RideEditor
      },
      {
        path: ':id/editar',
        name: 'viajes-ride-edit',
        component: RideEditor
      }
    ]
  }
]

export default routes
